// ============================================================================
// COURT PLACE ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const COURT_PLACE_BASE_PATH = '/CourtPlace';

export const courtPlaceEndpoints = {
  list: () => buildEndpoint(COURT_PLACE_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${COURT_PLACE_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${COURT_PLACE_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(COURT_PLACE_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${COURT_PLACE_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${COURT_PLACE_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${COURT_PLACE_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default courtPlaceEndpoints;
